import GenericInput from '@ui-components/Input/GenericInput';
import React from 'react';
import { Controller, Control } from 'react-hook-form';

interface FormInputProps {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  label?: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
  icon?: React.ReactNode;
  theme?: "light" | "dark";
  defaultValue?: string;
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  control,
  label,
  placeholder,
  required = false,
  helperText,
  icon,
  theme = "light",
  defaultValue = "",
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{ required: required ? `${label || 'This field'} is required` : false }}
      render={({ field, fieldState: { error } }) => (
        <GenericInput
          label={label}
          placeholder={placeholder}
          value={field.value}
          onChange={field.onChange}
          required={required}
          hasError={!!error}
          helperText={error ? error.message : helperText}
          icon={icon}
          theme={theme}
          className="mb-5"
        />
      )}
    />
  );
};

export default FormInput;
